import CommonModal from "@components/ui-components/modal";
import DataTableView from "@components/views/datatable-view";
import FormView from "@components/views/form-view";
import InputField from "@components/fields/input-field";
import LoadingButton from "@components/ui-components/loading-button";
import { STATUS_OPTIONS } from "./misc/constants";
import Select from "@components/fields/react-select/select";
import SwitchField from "@src/@core/components/fields/switch-field";
import size from "lodash/size";
import useDynamicStages from "./use-stages";
import usePageChange from "@hooks/use-page-change";

const DynamicStages = () => {
    const {
        loading,
        data,
        columns,
        setQueryParams,
        modalConfig,
        toggleModal,
        methods,
        upsertLoading,
        onSubmit
    } = useDynamicStages();

    const { handlePageChange, handlePerRowsChange } = usePageChange({
        setQueryParams
    });

    const isEdit = !!size(modalConfig.row._id);

    const {
        control,
        formState: { errors, isDirty },
        setValue
    } = methods;

    const content = [
        {
            leftChild: {
                title: "Enter Basic Details",
                desc : "Enter the basic details of the stages which you wish to create"
            },
            rightChild: (
                <>
                    <InputField
                        errors={errors}
                        id="name"
                        label="Name"
                        name="name"
                        required
                        control={control}/>
                    <SwitchField
                        label="Is Special Stage"
                        name="is_special_stage"
                        customOnChange={() => {
                            setValue("is_special_stage", "");
                        }}
                        control={control}
                        tooltipContent="Select the toggle to mark as a special stage"/>
                    <Select
                        label="Status"
                        control={control}
                        errors={errors}
                        id="status"
                        required
                        name="status"
                        options={STATUS_OPTIONS}/>
                </>
            )
        }
    ];

    return (
        <>
            <DataTableView
                moduleName={"Stages"}
                breadcrumbItems={{
                    items: [
                        {
                            title : "Stages",
                            active: true
                        }
                    ]
                }}
                actionItems={
                    <LoadingButton
                        color="primary"
                        icon="plus"
                        testId="add-stages"
                        onClick={() => toggleModal()}
                        subject="stages"
                        text="Add Stages"/>
                }
                tableProps={{
                    data      : data.stages,
                    columns,
                    handlePageChange,
                    handlePerRowsChange,
                    pagination: data.pagination
                }}
                loading={loading}/>
            <CommonModal
                title={`${isEdit ? "Edit" : "Add"} Stages`}
                body={<FormView content={content} />}
                confirmButton={{
                    txt    : isEdit ? "Update" : "Add",
                    icon   : "content-save",
                    loading: upsertLoading,
                    onClick: onSubmit
                }}
                type="extraLarge"
                isDirty={isDirty}
                loading={loading}
                handleModal={toggleModal}
                isOpen={modalConfig.open}/>
        </>
    );
};

export default DynamicStages;
